import { Avatar, Badge, Icon, IconButton, Tooltip } from "@material-ui/core";

function getInitials(name) {
  if (!name) return "";
  const parts = name.split(" ").filter((word) => word);
  return parts.length === 0
    ? ""
    : parts.length === 1
    ? parts[0][0]
    : parts[0][0] + parts[1][0];
}

export default function Profile({ classes, user, shoppingCarts }) {
  return (
    <>
      <Tooltip title="Página principal">
        <IconButton
          className={`${classes.authenticateButtons} ${classes.home}`}
          href="/"
        >
          <Icon className={classes.profileIcon}>home</Icon>
        </IconButton>
      </Tooltip>
      <Tooltip title="Carrinho de compras">
        <IconButton
          className={classes.authenticateButtons}
          href="/shopping-cart"
        >
          <Badge
            color="error"
            className={classes.shoppingBadge}
            badgeContent={
              shoppingCarts.length > 9 ? "+9" : shoppingCarts.length
            }
          >
            <Icon className={classes.profileIcon}>shopping_cart</Icon>
          </Badge>
        </IconButton>
      </Tooltip>
      <Tooltip
        title={`${user?.data?.nome}${
          user?.data?.categoria_centro_custo_descricao
            ? ` - ${user?.data?.categoria_centro_custo_descricao}`
            : ""
        }`}
      >
        <IconButton className={classes.authenticateButtons} href="/new-panel">
          <Avatar alt={user?.data?.nome} src={user?.data?.foto}>
            {getInitials(user?.data?.nome)}
          </Avatar>
        </IconButton>
      </Tooltip>
    </>
  );
}
